import { render, staticRenderFns } from "./ReportError.vue?vue&type=template&id=47e79cba&scoped=true&"
import script from "./ReportError.vue?vue&type=script&lang=js&"
export * from "./ReportError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e79cba",
  null
  
)

export default component.exports